/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Contract, ContractFactory, Interface, } from "ethers";
const _abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "operator",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
        ],
        name: "TokenReceived",
        type: "event",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "operator",
                type: "address",
            },
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
        ],
        name: "onERC721Received",
        outputs: [
            {
                internalType: "bytes4",
                name: "",
                type: "bytes4",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "0x608060405234801561001057600080fd5b506101f4806100206000396000f3fe608060405234801561001057600080fd5b506004361061002b5760003560e01c8063150b7a0214610030575b600080fd5b61004361003e3660046100cf565b610060565b6040516001600160e01b0319909116815260200160405180910390f35b60007f5343d39c46825e39cfee854256354ed1b3837af99997a3242ae29e831889773c868686868660405161009995949392919061016a565b60405180910390a150630a85bd0160e11b95945050505050565b80356001600160a01b03811681146100ca57600080fd5b919050565b6000806000806000608086880312156100e757600080fd5b6100f0866100b3565b94506100fe602087016100b3565b935060408601359250606086013567ffffffffffffffff8082111561012257600080fd5b818801915088601f83011261013657600080fd5b81358181111561014557600080fd5b89602082850101111561015757600080fd5b9699959850939650602001949392505050565b6001600160a01b038681168252851660208201526040810184905260806060820181905281018290526000828460a0840137600060a0848401015260a0601f19601f8501168301019050969550505050505056fea264697066735822122089b872565a87f7c2bc82ff6ecd12d24ec581b8cb06b87a8fa2952f2ec5b092a964736f6c63430008180033";
const isSuperArgs = (xs) => xs.length > 1;
export class ExampleERC721Receiver__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    connect(runner) {
        return super.connect(runner);
    }
    static createInterface() {
        return new Interface(_abi);
    }
    static connect(address, runner) {
        return new Contract(address, _abi, runner);
    }
}
ExampleERC721Receiver__factory.bytecode = _bytecode;
ExampleERC721Receiver__factory.abi = _abi;
//# sourceMappingURL=ExampleERC721Receiver__factory.js.map